/** ScheduleWeekDay flag values (matches the backend enum). */
export const scheduleWeekDayOptions = [
  { value: 1, label: 'Sun' },
  { value: 2, label: 'Mon' },
  { value: 4, label: 'Tue' },
  { value: 8, label: 'Wed' },
  { value: 16, label: 'Thu' },
  { value: 32, label: 'Fri' },
  { value: 64, label: 'Sat' },
];
